import { subject } from '@casl/ability';
import { Group } from '@mantine/core';
import { type FC } from 'react';

import { useApp } from '../../../providers/AppProvider';
import { Can } from '../../common/Authorization';
import MantineLinkButton from '../../common/MantineLinkButton';

interface Props {
    userName: string | undefined;
    projectUuid: string;
}

const LandingPanel: FC<Props> = ({ projectUuid }) => {
    const { user } = useApp();
    return (
        <Group position="apart" my="xl">
            <Can
                I="manage"
                this={subject('Explore', {
                    organizationUuid: user.data?.organizationUuid,
                    projectUuid: projectUuid,
                })}
            >
                <MantineLinkButton href={`/projects/${projectUuid}/tables`}>
                    Run a query
                </MantineLinkButton>
            </Can>
        </Group>
    );
};

export default LandingPanel;
